export interface FilterPill {
  key: string;
  type: FilterPillTypeEnum;
  label: string;
  categoryId?: string;
}

export enum FilterPillTypeEnum { 
  STATUS = 'status',
  CATEGORY = 'category',
  DATE = 'date',
}